// 接口返回状态码
export const CODES = {
  SUCCESS: '000000',
}